import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoyaltyCurrency } from '@rd/types/loyalty-currency.type';
import { getLoyaltyCurrencySelected } from '../../loyalty-currency/store/selectors/loyalty-currency.selectors';
import { CoreState } from '../../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyCurrencyService {
  loyaltyCurrencySelected: LoyaltyCurrency | null;

  constructor(private store: Store<CoreState>) {
    this.store
      .select(getLoyaltyCurrencySelected)
      .subscribe((loyaltyCurrency) => {
        this.loyaltyCurrencySelected = loyaltyCurrency;
      });
  }

  getPointsActivityTitleLoyaltyCurrencyName(): string {
    return this.loyaltyCurrencySelected?.shortName ?? '';
  }
}
